import React, { FunctionComponent } from 'react'
import { Heading, Text } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../utils/responsive'
import { useAppRouter, useCheckoutState } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { useMoney } from '../Money/useMoney'

export const ConsumerWelcome: FunctionComponent = () => {
  const { t } = useTranslation()
  const { locale } = useAppRouter()
  const { headingSize } = useCheckoutSizes()
  const { started, checkout } = useCheckoutState()
  const orderAmount = started?.consumerAmount ?? checkout?.amount
  const { formatMoney } = useMoney({
    locale,
    currency: orderAmount?.currency,
  })

  return (
    <>
      <Heading size={headingSize}>{t('consumerLending:paymentOptions.selectAnOption')}</Heading>
      <Text color='Subtle'>{t('consumerLending:paymentOptions.purchaseAmount', { amount: formatMoney(orderAmount?.amount) })}</Text>
    </>
  )
}
